"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchFormBase = void 0;
var React = require("react");
var core_1 = require("@athena-portal/core");
var operators_1 = require("rxjs/operators");
var services_1 = require("@falcon/services");
var Types_1 = require("../../../Types");
var SearchFormBase = /** @class */ (function (_super) {
    __extends(SearchFormBase, _super);
    function SearchFormBase(props) {
        var _this = _super.call(this, props) || this;
        _this.incrementLoadingQueueSize = function (callback) {
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize + 1
            }); }, callback);
        };
        _this.decrementLoadingQueueSize = function (callback) {
            if (_this.state.loadingQueueSize === 0) {
                return;
            }
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize - 1
            }); }, callback);
        };
        _this.handleSearchParameterChange = _this.handleSearchParameterChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }
    SearchFormBase.prototype.componentDidMount = function () {
        var _this = this;
        this.incrementLoadingQueueSize(function () {
            _this.lookupService
                .fetchLookupValues("all".concat(services_1.ProductsEnum.WOLF_MOTOR), "en-UK")
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe();
        });
    };
    SearchFormBase.prototype.handleSearchParameterChange = function (event) {
        this.props.onSearchParameterChange(event.target.name, event.target.value.trim());
    };
    SearchFormBase.prototype.handleSubmit = function (event) {
        event.preventDefault();
        this.props.onSearch();
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.FalconLookupService),
        __metadata("design:type", Object)
    ], SearchFormBase.prototype, "lookupService", void 0);
    return SearchFormBase;
}(React.Component));
exports.SearchFormBase = SearchFormBase;
//# sourceMappingURL=SearchFormBase.js.map